// extracted by mini-css-extract-plugin
export const textContainer = "svg-module--textContainer--3sVPQ";
export const text = "svg-module--text--2ybKy";
export const textDividerTop = "svg-module--textDividerTop--1bNm2";
export const textDividerBottom = "svg-module--textDividerBottom--3eduU";
export const Bg = "svg-module--Bg--2eeAC";
export const container = "svg-module--container--2K-KY";
export const title = "svg-module--title--3B2Fk";